import React, { useEffect } from "react";
import "./Timeline.css";
import homicideTimeline from "./chart";
import TimelineText from "./TimelineText";
import styles from "./Timeline.module.css";
import * as d3 from "d3";

const parse_time = d3.timeParse("%m/%d/%Y");

const Timeline = ({ data, timePeriod }) => {
  useEffect(() => homicideTimeline(timeline_data, timePeriod));

  const timeline_data = Array.from(
    d3.rollup(
      data.filter((d) => parse_time(d.dateofincident).getFullYear() === 2021),
      (v) => v.length,
      (d) => d.dateofincident
    )
  );

  return (
    <div className={styles.Timeline}>
      <h4>Homicides per day</h4>
      <div id="timeline_container">
        <div id="timeline_inner_container">
          <div id="timeline_labels">
            <div id="timeline_date_labels"></div>
            <div id="timeline_homicide_labels"></div>
          </div>
          <div id="timeline">
            <svg
              className="container"
              viewBox="0 0 700 250"
              preserveAspectRatio="none"
              width="100%"
              height="250px"
            ></svg>
          </div>
        </div>
      </div>
      <TimelineText data={timeline_data} />
    </div>
  );
};

export default Timeline;
